<div class="disclosure">
  <h1>Mandatory Public Disclosure</h1>
  <p>Open Access to Governance Policies and Administrative Guidelines</p>
  <button class="view-btn" (click)="openDialog()" mat-raised-button>
    View Public Disclosure
  </button>
  <!-- <app-documents
    *ngIf="isPublicDisclosureVisible"
    [slug]="slug"
    [disclosure]="disclosure"
    (close)="hidePublicDisclosure()"
  >
  </app-documents> -->
</div>
